import React, { Dispatch, FC, SetStateAction } from 'react';
import { Modal } from '@eika/modal';
import { ModalDialogProps } from '@eika/modal/src/ModalDialogTypes';
import { ButtonToggles } from '@eika/radio-button';
import { StandardButton } from '@eika/button';
import { useTranslate } from '../../../../../hooks/useTranslate';

type SetDownscalingModalProps = ModalDialogProps & {
    downscalingState: [boolean, Dispatch<SetStateAction<boolean>>];
};
const SetDownscalingModal: FC<SetDownscalingModalProps> = ({ onClose, open, downscalingState }) => {
    const [downscalinig, setDownscaling] = downscalingState;
    const translate = useTranslate();
    const yes = translate('yes');
    const no = translate('no');
    return (
        <Modal onClose={onClose} open={open} className="set-downscaling-modal">
            <div className="paragraph">
                <h2>{translate('riskReductionModalTitle')}</h2>
                <article>{translate('riskReductionModalDescriptiion')}</article>
            </div>
            <div className="paragraph">
                <h2>{translate('doYouWantToDownscale')}</h2>
                <article>{translate('downscale')}</article>

                <ButtonToggles
                    label=""
                    options={[{ value: yes }, { value: no }]}
                    selectedOption={downscalinig ? yes : no}
                    onChange={(value) => setDownscaling(value === yes)}
                />
            </div>
            <div className="button-row">
                <StandardButton size="large" buttonType="positive" onClick={onClose} placeholder="Ferdig">
                    {translate('finish')}
                </StandardButton>
            </div>
        </Modal>
    );
};

export default SetDownscalingModal;
